export default __webpack_public_path__ + "static/media/clients-landing-6.4f53cd46.jpg";